import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep } from 'lodash';

const moSider = observable({
  originPosition: 385, // 常亮
  topPosition: 385,
});

const changePosition = action((value: number) => {
  moSider.topPosition = value;
});

export default moSider;
export { changePosition };
